module.exports = __webpack_public_path__ + "static/media/logo_bib.04e06a53.png";